<!-- components/IconFont.vue -->
<template>
  <i class="iconfont" :class="iconClass" :style="iconStyle" @mouseover="hover = true" @mouseleave="hover = false" />
</template>

<script>
export default {
  name: "IconFont",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: "16px",
    },
    color: {
      type: String,
      default: "inherit",
    },
    hoverColor: {
      type: String,
      default: null, // eg: '#0062FF'
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    iconClass() {
      return ['iconfont', this.name];
    },
    iconStyle() {
      return {
        fontSize: typeof this.size === 'number' ? `${this.size}px` : this.size,
        color: this.hover && this.hoverColor ? this.hoverColor : this.color,
        transition: 'color 0.3s',
      };
    },
  },
};
</script>

<style scoped>
.iconfont {
  display: inline-block;
  line-height: 1;
}
</style>
